import { BrandCode, EnvConfig } from 'types';

const config: EnvConfig = {
	env: 'tst5',
	endpoints: {
		affirmApi: 'https://sandbox.affirm.com/js/v2/affirm.js',
		dictionaryApi: 'https://www.test5.royalcaribbean.com/bin/services/royal/dictionary',
		utilsApi: 'https://www.test5.royalcaribbean.com/utils/service',
	},
	publicKeys: {
		launchDarklyClientSideId: '61f97f4094fa1b16de90c38f',
		guestAccountClientId: '5rzs5saaH9sgrVA4U7r3U42Hxv8kBM9EsNXVEE7h693j4WQa538JB77389ghYscS',
		utilsGenerateId: '73cab9ae-48ae-48ca-b614-cde8d1872285',
	},
	brands: {
		[BrandCode.Celebrity]: {
			baseUrl: 'https://www.test5.celebritycruises.com',
			mapsBaseUrl: 'https://www.test5.celebritycruises.com',
			publicKeys: {
				affirmPublicId: '2NYPH852CY0PCTX0',
				appDynamicsAppKey: 'AD-AAB-AAT-KTS',
			},
			scripts: {
				appDynamics: '//cdn.appdynamics.com/adrum/adrum-latest.js',
			},
			resources: {
				favicon: '/favicon.ico',
			},
		},
		[BrandCode.RoyalCaribbean]: {
			baseUrl: 'https://www.test5.royalcaribbean.com',
			mapsBaseUrl: 'https://www.test5.royalcaribbean.com/content/dam',
			publicKeys: {
				affirmPublicId: 'C2JKB5O3PQ0H9R6X',
				appDynamicsAppKey: 'AD-AAB-AAU-NMZ',
			},
			scripts: {
				appDynamics: '//cdn.appdynamics.com/adrum/adrum-latest.js',
			},
			resources: {
				favicon: '/content/dam/royal/resources/icons/logo/favicon.ico',
			},
		},
	},
};

export default config;
